export const isSmartTag = (key: string): boolean =>
  key?.toLowerCase()?.startsWith("cloudchipr_");
